'use strict'

import Axios  from 'axios'
import Config from '../../configuration.js'

/**
 * http://localhost/Specif/EUDO_07676/root/SectionORM/commune/liste
 */


var chargerCommunes = function(){
    
  return new Promise(function(Resolve){
    Axios.get(Config.url.service + '/commune/liste') // renvoie les communes du departement du client
    .then(function(Reponse){
      Reponse.data.items.sort((a, b) => a.libelle.trim().localeCompare(b.libelle.trim()))  // Tri des valeurs par le libellé
      Resolve(Reponse.data.items)
    })
  })
}

var construcFormData = function(Cntxt){
  
  var form_data = new FormData()

  form_data.append('typeContrat',           Cntxt.getters['typeContrat']['id'])
  form_data.append('secteurActivite',       Cntxt.getters['secteurActivite']['id'])
  form_data.append('commune',               Cntxt.getters['commune']['id'])
  form_data.append('civilite',              Cntxt.getters['civilite']['id'])
  form_data.append('nom',                   Cntxt.getters['nom'])
  form_data.append('objetDemande',          Cntxt.getters['objetDemande'])
  form_data.append('prenom',                Cntxt.getters['prenom'])
  form_data.append('tel',                   Cntxt.getters['tel'])
  form_data.append('email',                 Cntxt.getters['email'])
  if(Cntxt.getters['cv'].name){
    form_data.append('cv',                    Cntxt.getters['cv'], Cntxt.getters['cv'].name)
  }
  if(Cntxt.getters['lettreMotivation'].name){
    form_data.append('lettreMotivation',      Cntxt.getters['lettreMotivation'], Cntxt.getters['lettreMotivation'].name)
  }
  
  return form_data
}


export default {
  namespaced: true,

  /**
   * STATE
   */
  state: {
    nom                 : "",
    prenom              : "",
    email               : "",
    tel                 : "",
    objetDemande        : "",
   
    communes            : [], // Liste des communes déduites de la liste des offres
 
    commune             : "",
    typeContrat         : "",
    secteurActivite     : "",
    civilite            : "",
    cv                  : [],
    lettreMotivation    : [],

    recherche             : true,
    message               : false,
  },

  /**
   * MUTATIONS
   */
  mutations: {

    /**
     * Actualise la liste des communes
     */
    communes(State,  Items){
      State.communes = Items
    },

    /**
     * Change la commune
     */
    commune(State, Value){
      State.commune = Value
    },

    /**
     * Change la transaction
     */
    secteurActivite(State, Value){
      State.secteurActivite = Value
    },

    /**
     * Change le type de contrat
     */
    typeContrat(State, Value){
      State.typeContrat = Value
    },

    /**
     * Change la civilité
     */
     civilite(State, Value){
      State.civilite = Value
    },

    /**
     * Change l'objet de la demande
     */
    objetDemande(State, Value){
        State.objetDemande = Value
    },

    /**
     * Change le cv
     */
     cv(State, Value){
       
      State.cv = Value
    },

    /**
     * Change la lettre de motivation
     */
    lettreMotivation(State, Value){
      State.lettreMotivation = Value
    },

    /**
     * Change le nom
     */
     nom(State, Value){
        State.nom = Value
    },

    /**
     * Change le prenom
     */
     prenom(State, Value){
        State.prenom = Value
    },

    /**
     * Change le telephone
     */
     tel(State, Value){
        State.tel = Value
    },

    /**
     * Change l'email
     */
     email(State, Value){
        State.email = Value
    },

    /**
     * Change recherche
     */
    recherche(State, Value){
      State.recherche = Value
    },

    /**
     * Change message
     */
    message(State, Value){
      State.message = Value
    },

  },

  /**
   * GETTERS
   */
  getters: {
    
    /**
     * Renvoie la liste des communes
     */
    communes(State){
      return State.communes
    },

    /**
     * Renvoie la commune
     */
    commune(State){
      return State.commune
    },

    /**
     * Renvoie la transaction
     */
    secteurActivite(State){
      return State.secteurActivite
    },

    /**
     * Renvoie le type de contrat
     */
    typeContrat(State){
      return State.typeContrat
    },

    /**
     * Renvoie le CV
     */
    cv(State){
      return State.cv
    },

    lettreMotivation(State){
      return State.lettreMotivation
    },

    /**
     * Renvoie la civilité
     */
    civilite(State){
      return State.civilite
    },

    /**
     * Renvoie l'objet de la demande
     */
    objetDemande(State){
        return State.objetDemande
    },

    /**
     * Renvoie le nom
     */
     nom(State){
        return State.nom
    },

    /**
     * Renvoie le prenom
     */
     prenom(State){
        return State.prenom
    },

    /**
     * Renvoie le telephone
     */
     tel(State){
        return State.tel
    },

    /**
     * Renvoie l'email
     */
      email(State){
        return State.email
    },

    /**
     * Renvoie recherche
     */
    recherche(State){
      return State.recherche
    },

    /**
     * Renvoie message
     */
     message(State){
      return State.message
    },

  },
  /**
   * ACTIONS
   */
  actions: {

    /**
     * Envoie la candidature au serveur
     */
     envoyerCandidature(Context){

        var form_data = construcFormData(Context)
  
        return Axios.post(Config.url.service + '/candidature/enregistrer', form_data,
        {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
        }) // Contacte l'orm pour récupérer les données
        .then(function(Reponse){
          
          if(Reponse.data.message == "ok"){
            Context.commit('recherche',  false)
            Context.commit('message',  true)
          }
          Promise.resolve();
        })
      },

    /**
     * Charge les communes
     */
    async listeCommune(Context){

      var items = await chargerCommunes() // Requete Ajax

      Context.commit('communes',  items)
    },
  }, //ACTIONS
}

